import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  commentEditorContainerEdit: {
    width: '99%',
    marginLeft: '10px',
    display: 'flex',
  },
  commentEditorContainer: {
    width: '99%',
    marginLeft: '10px',
    display: 'flex',
    '& .MuiOutlinedInput-multiline': {
      background: '#F5F5F8',
    },
  },
  arrowIcon: {
    fontSize: '3rem !important',
    color: '#3C419A',
    padding: '0',
  },
  xIcon: {
    padding: 0,
    bottom: '7px'
  },
  ellipsisText: {
    '& textarea': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      lineClamp: 1,
      boxOrient: 'vertical',
      width: 'calc(98%)',
      height: 'auto !important',
    },
  },
  ellipsisTextMoz: {
    '& textarea': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      lineClamp: 1,
      boxOrient: 'vertical',
      width: 'calc(98%)',
      height: 'auto !important',
      whiteSpace: 'nowrap',
    },
  },
  actionIcon: {
    color: 'white',
    marginTop: '-20px',
    '&:hover': {
      opacity: '1',
      cursor: 'pointer',
      color: '#3C419A',
    },
    '&:focus': {
      opacity: '1',
    },
    '&:active': {
      opacity: '1',
    },
  },
}));
